import React, { useEffect, useState } from "react";
import Papa from "papaparse";
import { fetchLeads, createLead } from "./api";

const ExportImportButtons = ({ onLeadsImported }) => {
  const [leads, setLeads] = useState([]);

  useEffect(() => {
    loadLeads();
  }, []);

  const loadLeads = async () => {
    const data = await fetchLeads();
    setLeads(data);
  };

  const handleExport = () => {
    const csv = Papa.unparse(leads);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "leads_export.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleImport = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      complete: async (results) => {
        for (const row of results.data) {
          const now = new Date().toISOString();
          let dataScadenzaParsed = null;

          if (row.data_scadenza) {
            const parsedDate = new Date(row.data_scadenza);
            if (!isNaN(parsedDate)) {
              dataScadenzaParsed = parsedDate.toISOString();
            }
          }

          const newLead = {
            id: Date.now() + Math.floor(Math.random() * 1000),
            nome: row.nome || "",
            telefono: row.telefono || "",
            email: row.email || "",
            note: row.note || "",
            stato: row.stato || "Lead",
            tag: [],
            storico_modifiche: [],
            data_creazione: now,
            data_modifica: now,
            data_scadenza: dataScadenzaParsed,
          };

          await createLead(newLead);
        }
        alert("✅ Importazione completata!");
        onLeadsImported();
      },
    });
  };

  return (
    <div className="flex gap-4 mb-4">
      <button onClick={handleExport} className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600">
        📄 Esporta Lead
      </button>

      <label className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 cursor-pointer">
        📂 Importa Lead
        <input type="file" accept=".csv" onChange={handleImport} className="hidden" />
      </label>
    </div>
  );
};

export default ExportImportButtons;
